import {
  Checkbox,
  Divider,
  Flex,
  FormControl,
  FormErrorMessage,
  Grid,
  GridItem,
  RadioGroup,
  Stack,
  Text,
  useBreakpointValue,
} from "@chakra-ui/react";
import { Field } from "formik";
import { RadioButtonField } from "../../../../../components/RadioButtonField";
import { CustomMultiSelectWField } from "../../../../../components/MultiSelect";
import { useState } from "react";
import MotivoSituacaoService from "../../../../../../main/services/MotivoSituacaoService";
import JustificativaService from "../../../../../../main/services/JustificativaService";
import { CustomSelectWField } from "../../../../../components/CustomSelectWField";
import { CustomDatepickerWField } from "../../../../../components/CustomDatepickerWField";
import { renderTooltip } from "../../../../../components/RenderTooltip";
import { perfis } from "../../../../../../helpers/Funcionalidades";

export const UniversoConsultaAba = ({
  children,
  props,
  isMobile,
  roleKeycloack,
}) => {
  const placement = useBreakpointValue({ md: "right" });
  const [hintSituacaoAtual, setHintSituacaoAtual] = useState(false);
  const [hintPeriodo, setHintPeriodo] = useState(false);
  const [motivos, setMotivos] = useState({ options: [], isLoading: false });

  const [tiposTransferencia] = useState({
    options: [
      { id: 1, label: "Entrada por Transferência" },
      { id: 2, label: "Saída por Transferência" },
      {
        id: 6,
        label:
          "Transferência para Acolhedor(a) do mesmo Serviço de Acolhimento",
      },
    ],
    isLoading: false,
  });

  const [justificativa, setJustificativa] = useState({
    options: [],
    isLoading: false,
  });

  const handleGetJustificativa = (id) => {
    setJustificativa({ ...justificativa, isLoading: true });

    JustificativaService.getJustificativa(id)
      .then((res) => {
        const allOption = { id: "", descricao: "Todos" };
        setJustificativa({
          options: [allOption, ...res.data],
          isLoading: false,
        });
      })
      .catch(() => console.log("Erro no get de justificativa"));
  };

  const handleGetMotivos = (props) => {
    setMotivos({ ...motivos, isLoading: true });

    const isConsulente = roleKeycloack.includes(perfis.perfilConsulente);

    MotivoSituacaoService.listarMotivoSituacao()
      .then((res) => {
        let motivoSituacaoDesligado = res.data.filter(
          (item) =>
            item.tipoSituacao.id === 2 &&
            item.dataFim === null &&
            (!isConsulente || item.riscoVida !== "S"),
        );

        let motivoSituacaoAcolhido = res.data.filter(
          (item) =>
            item.tipoSituacao.id === 1 &&
            item.dataFim === null &&
            (!isConsulente || item.riscoVida !== "S"),
        );

        let options = [];

        if (props?.values?.universoConsulta === 1) {
          options = motivoSituacaoAcolhido;
        } else if (props?.values?.universoConsulta === 2) {
          options = motivoSituacaoDesligado;
        }

        const allOption = { id: "", descricao: "Todos" };

        setMotivos({
          options: [allOption, ...options],
          isLoading: false,
        });
      })
      .catch(() => console.log("Erro no get de motivos"));
  };
  return (
    <>
      <Flex mb={4} justifyContent={"space-between"}>
        <Text
          fontWeight={700}
          fontSize="16px"
          lineHeight="21.6px"
          color={"#575553"}
        >
          Universo da Consulta
        </Text>
        {children}
      </Flex>

      <Text
        fontWeight={700}
        fontSize="14px"
        lineHeight="21.6px"
        color={"#169499"}
        mt={7}
        mb={2}
      >
        Selecione o Universo{" "}
        <Text as="span" color="red.500">
          *
        </Text>
      </Text>
      <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
      <Grid
        templateColumns={{
          base: "repeat(1, 1fr)",
          sm: "repeat(2, 1fr)",
          lg: "repeat(12, 2fr)",
        }}
        rowGap="24px"
        columnGap="18px"
        w="100%"
        mt="10px"
      >
        <>
          <GridItem colSpan={{ base: 9, "2xl": 7 }}>
            <Field name="universoConsulta">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.universoConsulta &&
                    form.touched.universoConsulta
                  }
                  id="universoConsulta"
                  width="max-content"
                  zIndex={"1"}
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("universoConsulta", value)
                    }
                  >
                    <Stack direction="row" gap={4}>
                      <RadioButtonField
                        id="radio-universoConsulta-1"
                        fieldName="universoConsulta"
                        value={1}
                        label="Acolhido"
                      />
                      <RadioButtonField
                        id="radio-universoConsulta-2"
                        fieldName="universoConsulta"
                        value={2}
                        label="Desligado"
                      />
                      <RadioButtonField
                        id="radio-universoConsulta-3"
                        fieldName="universoConsulta"
                        value={3}
                        label="Transferência"
                      />
                      <RadioButtonField
                        id="radio-universoConsulta-4"
                        fieldName="universoConsulta"
                        value={4}
                        label="Pendente"
                      />
                    </Stack>
                  </RadioGroup>
                  <FormErrorMessage mt="-1" mr="-16">
                    {form.errors.universoConsulta}
                  </FormErrorMessage>
                </FormControl>
              )}
            </Field>
          </GridItem>

          {(props?.values?.universoConsulta === 1 ||
            props?.values?.universoConsulta === 2) && (
            <GridItem colSpan={6}>
              <CustomMultiSelectWField
                fieldName="idsMotivosEntrada"
                label="Motivo"
                placeholder="Selecione o Motivo"
                getOptionLabel={(option) => option.descricao}
                getOptionValue={(option) => option.id}
                isLoading={motivos.isLoading}
                options={motivos.options}
                onChange={(value) => {
                  props.setFieldValue("idsMotivosEntrada", value ? value : "");
                }}
                values={props?.values?.idsMotivosEntrada[0] || ""}
                onFocus={() => handleGetMotivos(props)}
                visible
                todos
              />
            </GridItem>
          )}

          {props?.values?.universoConsulta === 3 && (
            <GridItem colSpan={6}>
              <CustomSelectWField
                fieldName="idTipoTransferencia"
                label="Tipo de Transferência*"
                placeholder="Selecione o Tipo"
                getOptionLabel={(option) => option.label}
                getOptionValue={(option) => option.id}
                options={tiposTransferencia.options}
                onChange={(value) => {
                  props.setFieldValue(
                    "idTipoTransferencia",
                    value ? value : "",
                  );

                  if (props.values.idTipoTransferencia?.id !== value?.id) {
                    props.setFieldValue("idJustificativas", "");
                  }
                }}
              />
            </GridItem>
          )}

          {((props?.values?.universoConsulta === 3 &&
            (props?.values?.idTipoTransferencia.id === 2 ||
              props?.values?.idTipoTransferencia.id === 6)) ||
            props?.values?.universoConsulta === 4) && (
            <GridItem colSpan={6}>
              <CustomMultiSelectWField
                fieldName="idJustificativas"
                label="Justificativa"
                placeholder="Selecione a Justificativa"
                getOptionLabel={(option) => option.descricao}
                getOptionValue={(option) => option.id}
                options={justificativa.options}
                values={props?.values?.idJustificativas[0] || ""}
                onChange={(value) => {
                  props.setFieldValue("idJustificativas", value);
                }}
                onFocus={() =>
                  handleGetJustificativa(
                    props?.values?.universoConsulta === 4
                      ? 5
                      : props?.values?.idTipoTransferencia?.id,
                  )
                }
                visible
                todos
              />
            </GridItem>
          )}

          <GridItem colSpan={12} rounded={"lg"}>
            <Flex gap={2}>
              <Text
                fontWeight={700}
                fontSize="14px"
                lineHeight="21.6px"
                color={"#169499"}
                mb={2}
              >
                Selecione um Período{" "}
                <Text as="span" color="red.500">
                  *
                </Text>
              </Text>
            </Flex>
            <Divider orientation="horizontal" borderColor={"#DDEBEA"} />

            <Field name="tipoPeriodo">
              {({ field, form }) => (
                <FormControl
                  isInvalid={
                    form.errors.tipoPeriodo && form.touched.tipoPeriodo
                  }
                  id="tipoPeriodo"
                  width="max-content"
                >
                  <RadioGroup
                    value={field.value}
                    onChange={(value) =>
                      props.setFieldValue("tipoPeriodo", value)
                    }
                    mt={4}
                  >
                    <Stack gap={4}>
                      <Flex gap={2}>
                        <RadioButtonField
                          fieldName="tipoPeriodo"
                          value="A"
                          label="Situação Atual"
                        />
                        {renderTooltip(
                          isMobile,
                          placement,
                          "Ao selecionar esse filtro, será considerada na pesquisa a data atual. Os filtros Saúde, Educação, Profissionalização, Visita, Situação Jurídica, Situação quanto à Adoção e Apadrinhamento, só serão habilitados com esse filtro acionado.",
                          hintSituacaoAtual,
                          setHintSituacaoAtual,
                        )}
                      </Flex>
                      <Flex gap={2}>
                        <RadioButtonField
                          fieldName="tipoPeriodo"
                          value="D"
                          label="Por Período"
                        />
                        {renderTooltip(
                          isMobile,
                          placement,
                          "Na pesquisa por período é possível que existam movimentos antes e depois das datas pesquisadas, porém compreendidas ainda no período da pesquisa.",
                          hintPeriodo,
                          setHintPeriodo,
                        )}
                      </Flex>
                    </Stack>
                    <FormErrorMessage mr="-14">
                      {form.errors.tipoPeriodo}
                    </FormErrorMessage>
                  </RadioGroup>
                </FormControl>
              )}
            </Field>

            {props.values?.tipoPeriodo === "D" && (
              <Stack direction={{ base: "column", md: "row" }} gap={4} mt={6}>
                <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
                  <CustomDatepickerWField
                    fieldName="dataInicio"
                    label={`Período de:${
                      !props.values.dataFim ? " *" : ""
                    }`}
                    placeholder="DD/MM/AAAA"
                    maxDate={new Date()}
                  />
                </GridItem>

                <GridItem colSpan={{ base: 3, sm: 3, lg: 1 }}>
                  <CustomDatepickerWField
                    fieldName="dataFim"
                    label={`Até:${
                      !props.values.dataInicio ? " *" : ""
                    }`}
                    placeholder="DD/MM/AAAA"
                    maxDate={new Date()}
                  />
                </GridItem>
              </Stack>
            )}
          </GridItem>

          <GridItem colSpan={12} rounded={"lg"}>
            <Text
              fontWeight={700}
              fontSize="14px"
              lineHeight="21.6px"
              color={"#169499"}
              mb={2}
            >
              Deseja Incluir:
            </Text>
            <Divider orientation="horizontal" borderColor={"#DDEBEA"} />
            <Stack direction="row" gap={2} mt={4}>
              {props?.values?.universoConsulta === 1 && (
                <Field name="entradasPorTransferencias">
                  {({ field, form }) => (
                    <FormControl
                      id="entradasPorTransferencias"
                      width="max-content"
                    >
                      <Checkbox
                        {...field}
                        isChecked={
                          props.values?.entradasPorTransferencias === true
                            ? true
                            : props.values?.entradasPorTransferencias === false
                              ? false
                              : props.values.entradasPorTransferencias?.includes(
                                    "Possui",
                                  )
                                ? true
                                : false
                        }
                        value="Possui"
                        name="entradasPorTransferencias"
                        id="entradasPorTransferencias"
                        whiteSpace="nowrap"
                      >
                        Entradas por Transferências
                      </Checkbox>
                      <FormErrorMessage>
                        {form.errors.entradasPorTransferencias}
                      </FormErrorMessage>
                    </FormControl>
                  )}
                </Field>
              )}

              {props?.values?.universoConsulta === 2 &&
                !props.values.idsMotivosEntrada.length && (
                  <Field name="saidaTransferencia">
                    {({ field, form }) => (
                      <FormControl id="saidaTransferencia" width="max-content">
                        <Checkbox
                          {...field}
                          isChecked={
                            props.values?.saidaTransferencia === true
                              ? true
                              : props.values?.saidaTransferencia === false
                                ? false
                                : props.values.saidaTransferencia?.includes(
                                      "Possui",
                                    )
                                  ? true
                                  : false
                          }
                          value="Possui"
                          name="saidaTransferencia"
                          id="saidaTransferencia"
                          whiteSpace="nowrap"
                        >
                          Saídas por Transferências
                        </Checkbox>
                        <FormErrorMessage>
                          {form.errors.saidaTransferencia}
                        </FormErrorMessage>
                      </FormControl>
                    )}
                  </Field>
                )}

              <Field name="maioresDezoito">
                {({ field, form }) => (
                  <FormControl id="maioresDezoito" width="max-content">
                    <Checkbox
                      {...field}
                      isChecked={
                        props.values?.maioresDezoito === true
                          ? true
                          : props.values?.maioresDezoito === false
                            ? false
                            : props.values.maioresDezoito?.includes("Possui")
                              ? true
                              : false
                      }
                      value="Possui"
                      name="maioresDezoito"
                      id="maioresDezoito"
                      whiteSpace="nowrap"
                    >
                      {props?.values?.universoConsulta === 4
                        ? "Os Maiores de 18 Anos que Não se Encontram na Situação de Pendente"
                        : "Maiores de 18 Anos"}
                    </Checkbox>
                    <FormErrorMessage>
                      {form.errors.maioresDezoito}
                    </FormErrorMessage>
                  </FormControl>
                )}
              </Field>
            </Stack>
          </GridItem>
        </>
      </Grid>
    </>
  );
};
